import { StoreService } from 'jigsaw';
import { HStack, Text } from 'ui_2';

type Props = {
  service: StoreService;
};

export const ArcadeStoreServiceRowSmall = ({ service }: Props) => {
  return (
    <HStack className='w-full max-w-[640px] items-center gap-2 rounded-[10px] bg-white px-3 py-2 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]'>
      <img
        src={service.smallLogoImageURL}
        className='h-10 w-10 rounded-[10px]'
        alt={`${service.title} small logo`}
      />
      <Text font='medium-sm'>{service.title}</Text>
    </HStack>
  );
};
